var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageNotSupported(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2629_13953",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 104,
    height: 104
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2629_13953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.9669 97.1751L79.5169 88.7251C79.3724 88.7973 79.2467 88.8334 79.1399 88.8334H22.9669C20.8002 88.8334 18.9585 88.0751 17.4419 86.5584C15.9252 85.0417 15.1669 83.2001 15.1669 81.0334V24.8604C15.1669 24.7535 15.203 24.6278 15.2752 24.4834L6.8252 16.0334L11.4835 11.4834L92.5169 92.5167L87.9669 97.1751ZM22.9669 82.3334H73.1252L63.3752 72.5834H28.1669L40.0835 56.7667L48.5335 67.6001L52.7585 61.9667L21.6669 30.8751V81.0334C21.6669 81.3945 21.794 81.7022 22.0482 81.9564C22.2995 82.2077 22.6058 82.3334 22.9669 82.3334ZM88.8335 76.5917L82.3335 70.0917V22.9667C82.3335 22.6056 82.2079 22.2994 81.9565 22.0481C81.7023 21.7938 81.3946 21.6667 81.0335 21.6667H33.9085L27.4085 15.1667H81.0335C83.2002 15.1667 85.0419 15.9251 86.5585 17.4417C88.0752 18.9584 88.8335 20.8001 88.8335 22.9667V76.5917Z",
    fill: "#979DA8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageNotSupported);
export default __webpack_public_path__ + "static/media/image-not-supported.0f25941676c5bd4d564a62eaeea84f80.svg";
export { ForwardRef as ReactComponent };